export default __webpack_public_path__ + "static/media/422.5db56f00.png";